export const createGroupErrorHandler = (
  groupZipCodeValue,
  groupCityValue,
  selectedState,
  groupIsInPerson,
  currentContext,
  setGroupZipCodeError,
  setGroupCityError,
  setSelectedStateError
) => {
  let errors = {};

  if (groupIsInPerson && currentContext === "createGroup") {
    console.log("In-person group validation");

    // ZIP Code Validation
    if (groupZipCodeValue.length === 0) {
      errors.zipCodeError = "ZipCode is required";
      setGroupZipCodeError(errors.zipCodeError);
    } else if (groupZipCodeValue.length !== 4) {
      errors.zipCodeError = "Must enter a 4-digit ZIP code";
      setGroupZipCodeError(errors.zipCodeError);
    } else {
      setGroupZipCodeError("");
    }

    // City Validation
    if (groupCityValue.length === 0) {
      errors.cityError = "City is required";
      setGroupCityError(errors.cityError);
    } else {
      setGroupCityError("");
    }

    // State Validation
    if (selectedState.length === 0) {
      errors.stateError = "State is required";
      setSelectedStateError(errors.stateError);
    } else {
      setSelectedStateError("");
    }
  }

  console.log("Errors after validation:", errors);
  return { errors };
};
